import React, { useEffect, useState } from "react";

import styles from "./BoxModal.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX } from "@fortawesome/free-solid-svg-icons";
import { ClipLoader } from "react-spinners";

import { api } from "../../../api/api";

import Select from "react-select";

const options = [
  { value: "AB", label: "Alberta" },
  { value: "BC", label: "British Columbia" },
  { value: "MB", label: "Manitoba" },
  { value: "NB", label: "New Brunswick" },
  { value: "NL", label: "Newfoundland and Labrador" },
  { value: "NT", label: "Northwest Territories" },
  { value: "NS", label: "Nova Scotia" },
  { value: "NU", label: "Nunavut" },
  { value: "ON", label: "Ontario" },
  { value: "PE", label: "Prince Edward Island" },
  { value: "QC", label: "Quebec" },
  { value: "SK", label: "Saskatchewan" },
  { value: "YT", label: "Yukon" },
];

function Modal(props) {
  const { isEditing, addressId } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({
    name: "",
    zip: "",
    address: "",
    city: "",
    province: "",
    addressId: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      if (isEditing) {
        setIsLoading(true);
        const data = await api.get(`/address/getAddress/${addressId}`);
        setData(data.data.address);
        setIsLoading(false);
      }
    };
    fetchData();
  }, [isEditing, addressId]);

  return (
    <div className={styles.container}>
      <form onSubmit={props.onSubmit}>
        <div className={styles.heading}>
          <div></div>
          <h3> {isEditing ? "Update Address" : "Add New Address"}</h3>
          <FontAwesomeIcon
            style={{ cursor: "pointer" }}
            onClick={props.onClose}
            icon={faX}
          />
        </div>
        {isLoading && (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <ClipLoader
              className={styles.loadingSpinner}
              loading={isLoading}
              color="#fff"
              size={30}
            />
          </div>
        )}
        {!isLoading && (
          <div className={styles.formContent}>
            <div>
              <div className={styles.nameContainer}>
                <input
                  required
                  id="addressId"
                  type="text"
                  defaultValue={isEditing ? data.addressId : ""}
                  placeholder="Address ID"
                />
              </div>
            </div>
            <div>
              <div className={styles.nameContainer}>
                <input
                  required
                  id="name"
                  type="text"
                  defaultValue={isEditing ? data.name : ""}
                  placeholder="Name"
                />
              </div>
            </div>
            <div>
              <input
                required
                id="zip"
                type="text"
                defaultValue={isEditing ? data.zip : ""}
                placeholder="Postal Code"
              />
            </div>
            <div>
              <input
                required
                id="address"
                type="text"
                defaultValue={isEditing ? data.address : ""}
                placeholder="Address"
              />
            </div>
            <div>
              <input
                required
                id="city"
                type="text"
                defaultValue={isEditing ? data.city : ""}
                placeholder="City"
              />
            </div>
            <div className={styles.controls}>
              <select
                id="province"
                type="text"
                defaultValue={isEditing ? data.province : ""}
                required
                placeholder="Province"
              >
                <option value="AB">Alberta</option>
                <option value="BC">British Columbia</option>
                <option value="MB">Manitoba</option>
                <option value="NB">New Brunswick</option>
                <option value="NL">Newfoundland and Labrador</option>
                <option value="NT">Northwest Territories</option>
                <option value="NS">Nova Scotia</option>
                <option value="NU">Nunavut</option>
                <option value="ON">Ontario</option>
                <option value="PE">Prince Edward Island</option>
                <option value="QC">Quebec</option>
                <option value="SK">Saskatchewan</option>
                <option value="YT">Yukon</option>
              </select>
            </div>
            <button
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                columnGap: "5px",
              }}
            >
              <ClipLoader loading={props.isLoading} color="#fff" size={20} />
              {!isEditing ? "Add Address" : "Update Address"}
            </button>
          </div>
        )}
      </form>
    </div>
  );
}

export default Modal;
